import { Injectable } from "@angular/core";
import { NotificationsService } from "angular2-notifications";
import { Observable } from "rxjs";
import { apiCallWrapper } from "../api/api.util";
import { IQueryFilter, QueryResult } from "../model/query.filter.class";
import { HasId } from "../model/generics";
import { IBlogCategory, IBlogCreateCategory } from "../model/ddb.model";
import { BlogCategoryApi } from "../api/blogCategory.api";

const className = "BlogCategoryService";

@Injectable()
export class BlogCategoryService {
	constructor(
		private notifications: NotificationsService,
		private categoryApi: BlogCategoryApi
	) {}

	public list(query: IQueryFilter) {
		return apiCallWrapper(this.categoryApi.list(query), {
			notificationsService: this.notifications,
			action: "Fetching blog-Category",
		});
	}

	public create(
		data: IBlogCreateCategory
	): Observable<IBlogCategory & HasId<string>> {
		return apiCallWrapper(this.categoryApi.create(data), {
			notificationsService: this.notifications,
			action: "Creating Blog-Category",
		});
	}

	public update(
		data: IBlogCreateCategory,
		id: string
	): Observable<IBlogCategory & HasId<string>> {
		return apiCallWrapper(this.categoryApi.update(id, data), {
			notificationsService: this.notifications,
			action: "Updating Blog-Category",
		});
	}

	public delete(id: string) {
		return apiCallWrapper(this.categoryApi.delete(id), {
			notificationsService: this.notifications,
			action: "Deleting Blog-Category",
		});
	}

	public webList() {
		return this.categoryApi.webList();
	}
}
